import { useState } from 'react';
import Modal from '../../../components/modal/Modal';
import { useStatusModalContext } from '../../../contexts/StatusModalContext';
import { useDict } from '../../../contexts/LanguageContext';
import { postCancelWithdrawal } from '../src/transactionApis';

const CancelWithdrawalModal = ({ handleClose, isOpen, flowId }) => {
    const dict = useDict();

    const { openStatusModal } = useStatusModalContext();

    const [isLoading, setIsLoading] = useState(false);

    const handleCancelWithdrawal = () => {
        setIsLoading(true);
        const wallet_cashflow_id = flowId;

        const payload = {
            wallet_cashflow_id,
        };
        postCancelWithdrawal(payload, handlePostCancelWithdrawal, handlePostCancelWithdrawalError);
        setIsLoading(false);
    };

    const handlePostCancelWithdrawal = () => {
        openStatusModal({
            title: dict.cancelWithdrawal,
            message: dict.cancelWithdrawalSuccessfulMessage,
            isSuccess: true,
            refresh: true,
        });
    };

    const handlePostCancelWithdrawalError = (error) => {
        openStatusModal({
            title: dict.cancelWithdrawal,
            message: dict.cancelWithdrawalFailedMessage,
            refresh: false,
            isSuccess: false,
        });
    };

    return (
        <Modal
            isOpen={isOpen}
            toggle={handleClose}
            onCancel={handleClose}
            onSubmit={handleCancelWithdrawal}
            cancelText={dict.cancel}
            submitText={dict.confirm}
            title={dict.cancelWithdrawal}
            headerType="invest-withdrawal"
            submitBtnProps={{
                disabled: isLoading,
            }}
            testID="cancelWithdrawalModal"
            submitShown
        >
            <div className="modal__body" style={{ textAlign: 'center' }}>
                <div data-cy="withdraw__confirmation" className="mx-auto">
                    <p>{dict.cancelWithdrawalConfirmation}</p>
                </div>
            </div>
        </Modal>
    );
};

export default CancelWithdrawalModal;
